import Select, { ControlProps, components } from 'react-select';
import { tw } from 'twind';
import { ProductOptionChoice } from 'lib/api';

type SelectorProps = {
  label: string;
  value?: ProductOptionChoice;
  onChange: (selection: string) => void;
  options: ProductOptionChoice[];
};

const ControlComponent = (props: ControlProps<ProductOptionChoice[], false>) => (
  <div className={tw`flex flex-row text-xs`}>
    <label>{props.selectProps.instanceId}:</label>
    <components.Control {...props} />
  </div>
);

const Selector = ({ label, value, onChange, options = [] }: SelectorProps) => {
  const onSelect = (newValue: any) => {
    onChange(newValue.value);
  };

  return (
    <Select
      isSearchable={false}
      isMulti={false}
      isClearable={false}
      value={value as any}
      onChange={onSelect}
      options={options as any[]}
      instanceId={label}
      styles={customStyles}
      captureMenuScroll={false}
      components={{ Control: ControlComponent }}
    />
  );
};

export default Selector;

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: '50%',
    paddingLeft: 10,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    padding: '2px 15px 2px 10px',
    margin: 0,
    '&:active': {
      backgroundColor: '#9CA3AF',
    },
    cursor: 'pointer',
    backgroundColor: state.isFocused ? '#EBEBEB' : '#FFFFFF',
    ...(state.isSelected && { fontWeight: 600, color: '#000000' }),
  }),
  singleValue: (provided: any) => ({
    ...provided,
    textDecoration: 'underline',
    color: '#5C5C5C',
  }),
  control: (provided: any) => ({
    display: 'flex',
    justifyContent: 'space-between',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: 0,
  }),
  indicatorSeparator: () => ({}),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    padding: 0,
    width: 0,
    height: 0,
    border: '4px solid transparent',
    borderTop: '5px solid #5C5C5C',
    borderBottom: 0,
    cursor: 'pointer',
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),
  menu: (provided: any) => ({
    ...provided,
    padding: '2px 1px 2px 0',
    marginTop: 5,
    borderRadius: 2,
    width: 'fit-content',
    border: '2px solid #000000',
    boxShadow: '3px 3px 0px #000000',
  }),
  menuList: (provided: any) => ({
    ...provided,
    padding: 0,
    overflowY: 'auto',
    maxHeight: 68,
    '::-webkit-scrollbar': {
      width: '2px',
      height: '0px',
    },
    '::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#000000',
      borderRadius: '10px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
    fontSize: 12,
  }),
};
